import React, { useEffect, useState } from "react";
import s from "./UpdateCar.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCarImages,
  getCarDetails,
  updateCar,
} from "../../redux/carSlice";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Row,
  Select,
  Upload,
} from "antd";
import {
  ArrowLeftOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import {
  bodyType,
  colors,
  condition,
  currency,
  driveType,
  fuel,
  inStock,
  rangeFuelVolume,
  rangeYear,
  registrationCouyntry,
  transmission,
  wheel,
} from "../../data";
import MySidebar from "../../components/MySidebar/MySidebar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";

const { TextArea } = Input;

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });

const UpdateCar = () => {
  const dispatch = useDispatch();
  const car = useSelector((state) => state.cars.carDetails);
  const params = useParams();
  const [form] = Form.useForm();
  const [modelsByBrand, setModelsByBrand] = useState();
  const [modelValue, setModelValue] = useState();
  const brands = useSelector((state) => state.cars.brandList);
  const models = useSelector((state) => state.cars.modelList);
  const carTypes = useSelector((state) => state.cars.categories);
  const [activeSubcategories, setActiveSubcategories] = useState(
    carTypes.find((it) => it.id === car?.vehicle_type?.id)?.sub_types
  );
  const [activeSubCategory, setActiveSubcategory] = useState();
  const [messageApi, contextHolder] = message.useMessage();
  const locations = useSelector((state) => state.cars.locations);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [file, setFile] = useState(
    car?.images?.map((it) => ({
      uid: it?.id.toString(),
      url: it?.image,
      status: "done",
      name: it?.image?.split("/").pop(),
    }))
  );
  const [changedFields, setChangedFields] = useState({});
  const [newImages, setNewImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [value, setValue] = useState("");
  const { width } = useWindowDimensions();

  useEffect(() => {
    setFile(
      car?.images?.map((it) => ({
        uid: it?.id.toString(),
        url: it?.image,
        status: "done",
        name: it?.image?.split("/").pop(),
      }))
    );

    form.setFieldsValue({
      vehicle_type: {
        value: car?.vehicle_type?.id,
        label: car?.vehicle_type?.name,
      },
      sub_vehicle_type: {
        value: car?.sub_vehicle_type?.id,
        label: car?.sub_vehicle_type?.name,
      },
      brand: { value: car?.brand?.id, label: car?.brand?.name },
      model: { value: car?.model?.id, label: car?.model?.name },
      year_of_manufacture: {
        value: car?.year_of_manufacture,
        label: car?.year_of_manufacture,
      },
      body_type: {
        value: car?.body_type,
        label: bodyType.find((it) => it === car?.body_type)?.name,
      },
      generation: car?.generation,
      fuel_type: {
        value: car?.fuel_type,
        label: fuel.find((it) => it === car?.fuel_type)?.name,
      },
      drive_type: {
        value: car?.drive_type,
        label: driveType.find((it) => it === car?.drive_type)?.name,
      },
      transmission: {
        value: car?.transmission,
        label: transmission.find((it) => it === car?.transmission)?.name,
      },
      engine: { value: car?.engine, label: car?.engine },
      steering_wheel: {
        value: car?.steering_wheel,
        label: wheel.find((it) => it === car?.steering_wheel)?.name,
      },
      color: {
        value: car?.color,
        label: colors.find((it) => it === car?.color)?.name,
      },
      condition: {
        value: car?.condition,
        label: condition.find((it) => it === car?.condition)?.name,
      },
      mileage: car?.mileage,
      availability: {
        value: car?.availability,
        label: inStock.find((it) => it === car?.availability)?.name,
      },
      seller_comment: car?.seller_comment,
      customs_clearance: car?.customs_clearance ? "Да" : "Нет",
      registration: {
        value: car?.registration,
        label: registrationCouyntry.find((it) => it === car?.registration)
          ?.name,
      },
      vincode: car?.vincode,
      installment: car?.installment ? "Есть" : "Нет",
      price: car?.price,
      currency: {
        value: car?.currency,
        label: currency.find((it) => it === car?.currency)?.name,
      },
      phone: car?.phone,
      location: { value: car?.location?.id, label: car?.location?.name },
    });
  }, [car, form]);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Вы обновили объявление о продаже авто!",
    });
  };

  const selectModels = (value) => {
    const data = models.filter((it) => it.brand.id === value);
    setModelsByBrand(data);
  };

  const selectSubcategories = (value) => {
    const data = carTypes.find((it) => it.id === value)?.sub_types;
    setActiveSubcategories(data);
  };

  const currentYear = new Date().getFullYear();
  const years = rangeYear(currentYear, currentYear - 50, -1);
  const fuelVolume = rangeFuelVolume(0.5, 6, 0.1);

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type='button'
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleValuesChange = (changedValues) => {
    setChangedFields((prevChangedFields) => ({
      ...prevChangedFields,
      ...changedValues,
    }));
  };

  const handleRemoveImages = (value) => {
    setDeletedImages((prevImages) => [...prevImages, Number(value.uid)]);
    setFile(file.filter((it) => it.uid !== value.uid));
  };

  const sendForm = async () => {
    const data = new FormData();

    Object.entries(changedFields).forEach(([key, value]) => {
      data.append(key, value.value || value);
    });

    newImages.length > 0 &&
      newImages.forEach((image) => {
        data.append("images", image.originFileObj);
      });

    if (deletedImages.length > 0) {
      dispatch(deleteCarImages({ image_ids: deletedImages }));
    }

    const res = await dispatch(updateCar({ id: Number(params.id), data }));

    if (res.type === "cars/updateCar/fulfilled") {
      success();
      dispatch(getCarDetails(Number(params?.id)));
      setNewImages([]);
    }
  };

  return (
    <div className={s.addCar}>
      {contextHolder}
      {width > 1000 ? <div className={s.top}>top</div> : null}

      <div className={s.main}>
        {width > 1000 ? <div className={s.left}>left</div> : null}
        <div className={s.center}>
          {width > 750 ? <Header /> : <MobileHeader />}

          <div className={s.contentWrapper}>
            <div className={s.content}>
              <div className={s.sidebar}>
                <MySidebar />
              </div>
              <div className={s.announcements}>
                <div>
                  <div className={s.contentWrapper1}>
                    <Link to='/myAccount' className={s.back}>
                      <ArrowLeftOutlined /> &nbsp;Назад
                    </Link>
                    <div className={s.header}>
                      <div className={s.top_photo_wrapper}>
                        <img
                          src={car?.images[0]?.image}
                          className={s.top_photo}
                        />
                      </div>
                      <h2 className={s.h2}>
                        <EditOutlined /> &nbsp;Обновить авто
                      </h2>
                    </div>
                    <div className={s.content1}>
                      <Form
                        form={form}
                        className={s.form}
                        encType='multipart/form-data'
                        layout='vertical'
                        onFinish={sendForm}
                        onValuesChange={handleValuesChange}
                      >
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Категория'
                              name='vehicle_type'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите  категорию",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Категории'
                                options={carTypes
                                  ?.filter(
                                    (el) =>
                                      el.id !== 4 && el.id !== 6 && el.id !== 7
                                  )
                                  ?.map((it) => ({
                                    value: it?.id,
                                    label: it?.name,
                                  }))}
                                onSelect={(value) => {
                                  selectSubcategories(value);
                                  setActiveSubcategory(undefined);
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              name='sub_vehicle_type'
                              label='Тип транспортного средства'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите тип транспортного средства",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Тип транспортного средства'
                                options={activeSubcategories?.map((it) => ({
                                  value: it?.id,
                                  label: it?.name,
                                }))}
                                onSelect={(value) =>
                                  setActiveSubcategory(value)
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Марка'
                              name='brand'
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите Марку",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Марка'
                                options={brands?.map((it) => ({
                                  value: it?.id,
                                  label: it?.name,
                                }))}
                                onSelect={(value) => {
                                  selectModels(value);
                                  setModelValue(undefined);
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Модель'
                              name='model'
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите Модель",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Модель'
                                options={modelsByBrand?.map((it) => ({
                                  value: it?.id,
                                  label: it?.name,
                                }))}
                                onSelect={(value) => setModelValue(value)}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              name='year_of_manufacture'
                              label='Год выпуска'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите год выпуска авто",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Год выпуска'
                                options={years?.map((it) => ({
                                  value: it,
                                  label: it,
                                }))}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              name='body_type'
                              label='Тип кузова'
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите кузов",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Кузов'
                                options={bodyType}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item label='Поколение' name='generation'>
                              <input
                                placeholder='Укажите поколение, если есть'
                                className={s.input}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Тип топлива'
                              name='fuel_type'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите тип топлива",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Тип топлива'
                                options={[
                                  { value: "hybrid", label: "Гибрид" },
                                  { value: "gasoline", label: "Бензин" },
                                  { value: "gas", label: "Газ" },
                                  { value: "diesel", label: "Дизель" },
                                  { value: "electric", label: "Электрический" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Привод'
                              name='drive_type'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите привод",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Привод'
                                options={[
                                  {
                                    value: "front_wheel_drive",
                                    label: "Передний",
                                  },
                                  {
                                    value: "rear_wheel_drive",
                                    label: "Задний",
                                  },
                                  { value: "all_wheel_drive", label: "Полный" },
                                  { value: "other", label: "Другой" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Коробка передач'
                              name='transmission'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите тип коробки передач",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Укажите тип коробки передач'
                                options={[
                                  { value: "automatic", label: "Автомат" },
                                  { value: "manual", label: "Механика" },
                                  {
                                    value: "semi_automatic",
                                    label: "Полуавтоматическая",
                                  },
                                  {
                                    value: "continuously_variable",
                                    label: "Вариатор",
                                  },
                                  {
                                    value: "dual_clutch",
                                    label:
                                      "Роботизированная с двойным сцеплением",
                                  },
                                  { value: "tiptronic", label: "Типтроник" },
                                  {
                                    value: "direct_shift_gearbox",
                                    label: "Прямой переключатель передач",
                                  },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Руль'
                              name='steering_wheel'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите расположение руля",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Укажите расположение руля'
                                options={[
                                  { value: "left", label: "Слева" },
                                  { value: "right", label: "Справа" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Объем двигателя'
                              name='engine'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите объем двигателя",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Объем двигателя'
                                options={fuelVolume?.map((it) => ({
                                  value: it,
                                  label: it,
                                }))}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <div className={s.subtile}>Описание и комплектация</div>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Цвет'
                              name='color'
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите цвет",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Цвет'
                                options={colors}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Состояние'
                              name='condition'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите состояние авто",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Состояние'
                                options={[
                                  { value: "new", label: "Новое" },
                                  { value: "perfect", label: "Идеальное" },
                                  { value: "good", label: "Хорошее" },
                                  {
                                    value: "fair",
                                    label: "Удовлетворительное",
                                  },
                                  { value: "poor", label: "Аварийное/на ходу" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Пробег, км'
                              name='mileage'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите пробег",
                                },
                              ]}
                            >
                              <input
                                placeholder='Укажите пробег'
                                className={s.input}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='В наличии'
                              name='availability'
                              rules={[
                                {
                                  required: true,
                                  message: "В наличии",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='В наличии'
                                options={[
                                  { value: "in_stock", label: "В наличии" },
                                  { value: "to_order", label: "На заказ" },
                                  { value: "on_the_way", label: "В пути" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={24}>
                            <Form.Item
                              label='Описание'
                              name='seller_comment'
                              rules={[
                                {
                                  required: true,
                                  message: "Опишите ваше авто",
                                },
                              ]}
                            >
                              {/* <TextArea
                                placeholder='Опишите ваше авто'
                                className={s.textarea}
                              /> */}
                              <ReactQuill value={value} onChange={setValue} />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Растаможен'
                              name='customs_clearance'
                              rules={[
                                {
                                  required: true,
                                  message: "Растаможен",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Растаможен'
                                options={[
                                  { value: true, label: "Да" },
                                  { value: false, label: "Нет" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Учет'
                              name='registration'
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите страну учета",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Выберите страну учета'
                                options={[
                                  { value: "china", label: "Китай" },
                                  { value: "kyrgyzstan", label: "Кыргызстан" },
                                  { value: "russia", label: "Россия" },
                                  { value: "korea", label: "Корея" },
                                  {
                                    value: "not_registered",
                                    label: "Не стоит на учете",
                                  },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item label='Vincode' name='vincode'>
                              <input
                                placeholder='Укажите винкод'
                                className={s.input}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item label='Рассрочка' name='installment'>
                              <Select
                                className={s.select}
                                placeholder='Укажите есть ли возможность рассрочки'
                                options={[
                                  { value: "yes", label: "Есть" },
                                  { value: "no", label: "Нет" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 8 : 16}>
                            <Form.Item
                              label='Цена'
                              name='price'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите цену",
                                },
                              ]}
                            >
                              <input placeholder='Цена' className={s.input} />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 4 : 8}>
                            <Form.Item
                              label='Валюта'
                              name='currency'
                              initialValue={{ value: "usd", label: "USD" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите валютy",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Выберите валютy'
                                options={[
                                  { value: "usd", label: "USD" },
                                  { value: "cny", label: "CNY" },
                                  { value: "kgs", label: "KGS" },
                                  { value: "rub", label: "RUB" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Телефон'
                              name='phone'
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите номер телефона",
                                },
                              ]}
                            >
                              <input
                                placeholder='Укажите номер телефона'
                                className={s.input}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={width > 500 ? 12 : 24}>
                            <Form.Item
                              label='Местоположение'
                              name='location'
                              rules={[
                                {
                                  required: true,
                                  message: "Выберите местоположение",
                                },
                              ]}
                            >
                              <Select
                                className={s.select}
                                placeholder='Выберите местоположение'
                                options={locations?.map((it) => ({
                                  value: it?.id,
                                  label: it?.name,
                                }))}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={24}>
                          <Col span={24}>
                            <Form.Item name={"images"} label={"Загрузите фото"}>
                              <Upload
                                listType='picture-card'
                                fileList={file}
                                onPreview={handlePreview}
                                multiple={true}
                                onRemove={(value) => handleRemoveImages(value)}
                                beforeUpload={() => false}
                              ></Upload>
                              {previewImage && (
                                <Image
                                  wrapperStyle={{
                                    display: "none",
                                  }}
                                  preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) =>
                                      setPreviewOpen(visible),
                                    afterOpenChange: (visible) =>
                                      !visible && setPreviewImage(""),
                                  }}
                                  src={previewImage}
                                />
                              )}
                            </Form.Item>

                            <Form.Item
                              name='newImages'
                              style={{ marginTop: "30px" }}
                            >
                              <Upload
                                listType='picture-card'
                                fileList={newImages}
                                onPreview={handlePreview}
                                onChange={(e) => setNewImages(e.fileList)}
                                multiple={true}
                                beforeUpload={() => false}
                              >
                                {uploadButton}
                              </Upload>
                              {previewImage && (
                                <Image
                                  wrapperStyle={{
                                    display: "none",
                                  }}
                                  preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) =>
                                      setPreviewOpen(visible),
                                    afterOpenChange: (visible) =>
                                      !visible && setPreviewImage(""),
                                  }}
                                  src={previewImage}
                                />
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row span={24} className={s.btn_row}>
                          <Button className={s.btn} htmlType='submit'>
                            <EditOutlined />
                            &nbsp;Отредактировать авто
                          </Button>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {width > 1000 ? <div className={s.right}>right</div> : null}
      </div>
      <Footer />
    </div>
  );
};

export default UpdateCar;
